/**
 * @class Contact
 * @param element HTMLElement
 * @constructor
 */
function Contact(element){
	if(element === null){
		throw new TypeError("Invalid element.");
	}

	this._element = element;
	this._document = element.ownerDocument;
	this._window = this._document.defaultView;
	this._focusChangeHandlerBound = this._focusChangeHandler.bind(this);
	this._mouseMoveHandlerBound = this._mouseMoveHandler.bind(this);
	this._submitHandlerBound = this._submitHandler.bind(this);
	this._loadHandlerBound = this._loadHandler.bind(this);

	this._form = this._element.getElementsByClassName("contact_form")[0];
	this._form.addEventListener("submit", this._submitHandlerBound, false);
	this._fieldset = this._form.getElementsByClassName("contact_form-fieldset")[0];

	for (var pairIndex = 0, pairs = this._window.location.search.substr(1).split("&"), numPairs = pairs.length; pairIndex < numPairs; pairIndex++) {
		var pair = pairs[pairIndex].split("=");
		if(pair[0] in this._form.elements){
			this._form.elements[pair[0]].value = pair.length > 1 ? pair[1] : "";
		}
	}

	/** @type NodeList */
	var elements;
	if((elements = this._form.getElementsByClassName("contact_form-input--message")).length){
		this._messageInput = elements[0];
		this._messageInput.addEventListener("focus", this._focusChangeHandlerBound, false);
		this._messageInput.addEventListener("blur", this._focusChangeHandlerBound, false);
		this._messageInput.addEventListener("mouseenter", this._mouseMoveHandlerBound, false);
		this._messageInput.addEventListener("mouseleave", this._mouseMoveHandlerBound, false);
	}

//	this._scrollHandler();
}

/** @type DocumentView */
Contact.prototype._window = null;
/** @type HTMLDocument */
Contact.prototype._document = null;
/** @type HTMLElement */
Contact.prototype._element = null;
/** @type HTMLFormElement */
Contact.prototype._form = null;
/** @type HTMLTextAreaElement */
Contact.prototype._messageInput = null;
Contact.prototype._focusChangeHandlerBound = null;
Contact.prototype._mouseMoveHandlerBound = null;
Contact.prototype._submitHandlerBound = null;
Contact.prototype._loadHandlerBound = null;
/** @type XMLHttpRequest */
Contact.prototype._sender = null;
/** @type FormDataEncoder */
Contact.prototype._formEncoder = null;
/** @type {Number} */
Contact.prototype._messageTimeoutID = 0;
Contact.prototype._fieldset = null;
Contact.prototype._result = null;
Contact.MESSAGE_TIMEOUT = 3000;

/**
 *
 * @param event Event
 * @private
 */
Contact.prototype._focusChangeHandler = function _focusChangeHandler(event){
	if(event.type == "focus"){
		this._form.classList.add("contact_form--message-input-focus");
	}else{
		this._form.classList.remove("contact_form--message-input-focus");
	}
};

/**
 *
 * @param event Event
 * @private
 */
Contact.prototype._mouseMoveHandler = function _mouseMoveHandler(event){
	if(event.type == "mouseenter"){
		this._form.classList.add("contact_form--message-input-hover");
	}else{
		this._form.classList.remove("contact_form--message-input-hover");
	}
};

Contact.prototype._submit = function _submit(){
	this._endResultMessage();
	var entries = FormDataReader.getEntries(this._form);

	if(this._sender){
		this._sender.abort();
	}else{
		this._sender = new XMLHttpRequest();
		this._sender.addEventListener("load", this._loadHandlerBound, false);
		this._formEncoder = new FormDataEncoder();
	}
	//this._form.getAttribute("action")/*field name=action override form.action, use getAttribute instead*/
	this._sender.open(this._form.method, this._form.dataset.action);
	this._sender.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
	this._formEncoder.encode(entries);
	// here: this._formEncoder.readyState == FormDataEncoder.DONE
	this._sender.send(this._formEncoder.result);
};

Contact.prototype._submitHandler = function _submitHandler(event){
	this._submit();
	event.preventDefault();
};

Contact.prototype._loadHandler = function _loadHandler(event){
	var data = JSON.parse(this._sender.responseText);
	// Update security fields
	this._form.elements.nonce_time.value = data.nonce_time;
	this._form.elements.nonce.value = data.nonce;
	var success = data.code == 1;
	if(success){
		// Remove sent message
		this._form.elements.message.value = "";
	}
	this._form.classList.add("contact_form--result");
	this._result = this._document.createElement("div");
	this._result.className = "contact_form-result-container";
	var div = this._document.createElement("div");
	div.className = "contact_form-result " + (success ? "contact_form-result--success" : "contact_form-result--error");
	var p = this._document.createElement("p");
	p.className = "contact_form-result-content";
	p.textContent = data.message;
	div.appendChild(p);
	this._result.appendChild(div);
	this._fieldset.parentNode.insertBefore(this._result, this._fieldset);

	this._messageTimeoutID = setTimeout(this._messageTimeoutHandler.bind(this), Contact.MESSAGE_TIMEOUT);
};

Contact.prototype._endResultMessage = function _endResultMessage(){
	this._form.classList.remove("contact_form--result");
	if(this._result){
		this._result.parentNode.removeChild(this._result);
		this._result = null;
	}
};

Contact.prototype._messageTimeoutHandler = function _messageTimeoutHandler(){
	this._endResultMessage();
};

Contact.prototype.clear = function clear(){
	clearTimeout(this._messageTimeoutID);
	if(this._messageInput){
		this._messageInput.removeEventListener("focus", this._focusChangeHandlerBound, false);
		this._messageInput.removeEventListener("blur", this._focusChangeHandlerBound, false);
		this._messageInput.removeEventListener("mouseenter", this._mouseMoveHandlerBound, false);
		this._messageInput.removeEventListener("mouseleave", this._mouseMoveHandlerBound, false);
	}
	if(this._sender){
		this._sender.removeEventListener("load", this._loadHandlerBound, false);
		this._sender.abort();
	}
	this._form.removeEventListener("submit", this._submitHandlerBound, false);
};